module.exports = __webpack_public_path__ + "static/media/tournament-description-bg.79f437f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/tournament-description-bg.png
// module id = 845
// module chunks = 103